import { useState } from 'react';
import { api, ApiError, PublicUser } from '../api';
import { clearPinSkip, rememberPinLogin, skipPinOffer } from '../lib/pin';
import { PinPad } from './PinPad';

/*
 * Установка пин-кода после входа по логину и паролю: код вводится дважды.
 * Логин запоминается на устройстве — дальше вход одним пином.
 */

export function PinSetup({
  user,
  onDone,
  onSkip,
}: {
  user: PublicUser;
  onDone: (u: PublicUser) => void;
  onSkip: () => void;
}) {
  const [first, setFirst] = useState<string | null>(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const handle = async (pin: string) => {
    if (!first) {
      setErr('');
      setFirst(pin);
      return;
    }
    if (pin !== first) {
      setFirst(null);
      setErr('Коды не совпали — начните заново');
      return;
    }
    setBusy(true);
    try {
      const r = await api.setPin(pin);
      rememberPinLogin(user.login, `${user.firstName} ${user.lastName}`.trim());
      clearPinSkip();
      onDone(r.user);
    } catch (e) {
      setFirst(null);
      setErr(e instanceof ApiError ? e.message : 'Не удалось сохранить пин-код');
    } finally {
      setBusy(false);
    }
  };

  const skip = () => {
    skipPinOffer(user.login);
    onSkip();
  };

  return (
    <div className="pin-modal-back">
      <div className="pin-card">
        <PinPad
          key={first ? 'repeat' : 'first'}
          title={first ? 'Повторите пин-код' : 'Пин-код для быстрого входа'}
          hint={
            first
              ? 'Введите те же четыре цифры ещё раз.'
              : 'Придумайте 4 цифры — ими вы будете входить в приложение на этом устройстве. Логин и пароль останутся запасным входом.'
          }
          error={err || undefined}
          busy={busy}
          onComplete={handle}
          onCancel={first ? () => { setFirst(null); setErr(''); } : skip}
          cancelLabel={first ? 'Ввести заново' : 'Не сейчас'}
        />
      </div>
    </div>
  );
}
